import React, { useEffect, useState } from "react"
import { useSelector } from 'react-redux'
import { DirectMessagingBEService } from 'src/_services'
import { initBEClient, initGroup } from 'src/_helpers'
import moment from "moment-timezone";
export const ChatGroupList = () => {
  const [groups, setGroups] = useState([])
  const DMStore = useSelector((state) => state.DirectMessaging);
  useEffect(() => {
    new DirectMessagingBEService({ page_size: 100 }).group().then(e => {
      var gr = e.results.filter(e => e.customer_name)
      initGroup(gr)
      setTimeout(() => {
        onSelected(gr[0] || {})
      }, 100);
    }).catch(e => console.log(e))
  }, []);
  useEffect(() => {
    setGroups(DMStore?.group?.sort((a, b) => moment(b.last_customer_chat_at) - moment(a.last_customer_chat_at)))
  }, [DMStore, DMStore?.group]);
  const onSelected = (gr) => {
    console.log(gr)
    new DirectMessagingBEService({ page_size: 100 }).history(gr.id).then(({ history }) => {
      initBEClient({
        ...gr,
        message: history.results,
        client_id: gr.device_id,
        customer_name: gr.customer_name,
        customer_phone: gr.customer_phone,
        room_name: gr.room_name,
        group_id: gr.id,
        status: 'BACKEND'
      })
    }).catch(e => console.log(e))
  }
  return (
    <div className="contacts">
      {(groups || []).map((e) => {
        return <div className="contact" key={e.id} onClick={() => onSelected(e)}>
          <div className="pic">{e.room_name || '0000'}</div>
          <div className="badge">
            {e.customer_chat_count > 0 ? e.customer_chat_count : ''}
          </div>
          <div className="name">
            {e.customer_name}
          </div>
          <div className="message">
            {e.customer_phone}
          </div>
        </div>
      })}
    </div>
  );
};
